import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/header";
import Footer from "./components/footer";
import Accueil from "./pages/accueil";
import MentionsLegales from "./pages/mentionsLegales";
import PolitiqueConfidentialite from "./pages/politiqueConfidentialite";
import ConditionsUtilisation from "./pages/conditionsUtilisation";
import Cookies from "./pages/cookies";
// import Contact from "./pages/contact";
import Boutique from "./pages/boutique";
import Panier from "./pages/panier";
import Checkout from "./pages/checkout";
import OrderConfirmation from "./pages/orderConfirmation";
import FrmAuth from "./pages/auth";
import FrmAdmin from "./pages/admin";
import Profil from "./pages/profil";
import TestLoader from "./pages/test";
import NotFound from "./pages/notFound";
import ScrollTopButton from "./components/ScrollTopButton";

import HeaderMeta from "./components/HeaderMeta";

import { AuthProvider } from "./context/AuthContext";// Context d'authentification context = variables globales \\
import { LoaderProvider } from "./context/LoaderContext";
import { GlobalPropertyProvider } from "./context/GlobalPropertyContext";
import { CartProvider } from "./context/CartContext";
import GlobalLoader from "./components/GlobalLoader";

export default function App() {
  return (
    <LoaderProvider>
      <AuthProvider>
        <GlobalPropertyProvider>
          <CartProvider>
          <Router>
          <HeaderMeta />
          <Header />
          <Routes>
            <Route path="/" element={<Accueil />} />
            <Route path="/boutique" element={<Boutique />} />
            <Route path="/panier" element={<Panier />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/commande-confirmee" element={<OrderConfirmation />} />
            <Route path="/auth" element={<FrmAuth />} />
            <Route path="/profil" element={<Profil />} />
            <Route path="/account" element={<Profil />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/conditions-utilisation" element={<ConditionsUtilisation />} />
            <Route path="/cookies" element={<Cookies />} />
            {/* <Route path="/contact" element={<Contact />} />*/}
            <Route path="/admin/*" element={<FrmAdmin />} />

            <Route path="/test" element={<TestLoader />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <ScrollTopButton />
          <Footer />
          <GlobalLoader />
        </Router>
        </CartProvider>
        </GlobalPropertyProvider>
      </AuthProvider>
    </LoaderProvider>
  );
}